import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./components/login/Login";
import { CssBaseline } from "@mui/material";
import UserListing from "./components/user/UserListing";
import AccessListing from "./components/access/AccessListing";
import DivisionListing from "./components/division/DivisionListing";
import OraganizationListing from "./components/oraganization/OraganizationListing";
import Worklist from "./components/worklist/Worklist";
import WorkListDashboard from "./components/worklist/WorkListDashboard";
import SampEmpListing from "./components/sampemp/SampEmpListing";
import WorkProcessListing from "./components/workprocess/WorkProcessListing";
import AnnextureListing from "./components/annexture/AnnextureListing";
import ChapterListing from "./components/chapter/ChapterListing";
import QuestionListing from "./components/question/QuestionListing";
import SuggandactrefListing from "./components/suggandactref/SuggandactrefListing";
import ScheduleListing from "./components/schedule/ScheduleListing";
import ViewDocumentPage from "./components/schedule/ViewDocumentPage";
import AuditeeListing from "./components/auditee/AuditeeListing";
import "bootstrap/dist/css/bootstrap.min.css";
import NearMissAccidentListing from "./components/nearMissAccident/NearMissAccidentListing";
import DropdownListing from "./components/dropdown/DropdownListing";
import ObservationSelect from "./components/observations/InspectionObservation";
import SampEmpProfile from "./components/sampemp/SampEmpProfile";
import ObservationSelectView from "./components/observations/InspectionObsHistory";
import FlashScreen from "./components/FlashScreen";
import MainLayout from "./components/layout/MainLayout";
import ObservationSelectViewUser from "./components/observations/InspectionObsUserHistory";
import ObservationSelectUser from "./components/observations/InspectionObsUser";
import AuditObservation from "./components/observations/AuditObservation";
import AuditObsHistory from "./components/observations/AuditObsHistory";
import AuditObsUser from "./components/observations/AuditObsUser";
import AuditObsUserHistory from "./components/observations/AuditObsHistory";

import HomePage from "./components/login/pages/HomePage";
import WhoWeAre from "./components/login/pages/WhoWeAre";
import OurValues from "./components/login/pages/OurValues";
import PlatformFeatures from "./components/login/pages/PlatformFeatures";
import ContactUs from "./components/login/pages/ContactUs";
import PublicLayout from "./components/layout/PublicLayout";
import PrivacyPolicy from "./components/login/pages/Privacy";
import TermsOfUse from "./components/login/pages/TermsCondition";
import RoleListing from "./components/role/RoleListing";
import SessionExpired from "./components/schedule/SessionExpired";

const App = () => {
  const [showSplash, setShowSplash] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/observationViewforUser")) {
      document.title = "View User Reports";
    } else if (location.pathname.startsWith("/observationView")) {
      document.title = "View Reports";
    } else if (location.pathname.startsWith("/observationforUser")) {
      document.title = "User Reports";
    } else if (location.pathname.startsWith("/observation")) {
      document.title = "Reports";
    } else {
      document.title = "Parivikshak";
    }
  }, [location.pathname]);

  return showSplash ? (
    <FlashScreen duration={2500} onComplete={() => setShowSplash(false)} />
  ) : (
    <>
      <CssBaseline />
      <div style={{ height: "100%", width: "100%" }}>
        {/* <Header /> */}

        <main>
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />

            <Route
              path="/home"
              element={
                <PublicLayout>
                  <HomePage />
                </PublicLayout>
              }
            />
            <Route
              path="/who-we-are"
              element={
                <PublicLayout>
                  <WhoWeAre />
                </PublicLayout>
              }
            />
            <Route
              path="/our-values"
              element={
                <PublicLayout>
                  <OurValues />
                </PublicLayout>
              }
            />
            <Route
              path="/platform-features"
              element={
                <PublicLayout>
                  <PlatformFeatures />
                </PublicLayout>
              }
            />
            <Route
              path="/contact-us"
              element={
                <PublicLayout>
                  <ContactUs />
                </PublicLayout>
              }
            />
            <Route path="/view" element={<ViewDocumentPage />} />

            <Route path="/notfound" element={<SessionExpired />} />

            <Route path="/login" element={<Login />} />
            <Route
              path="/workprocess"
              element={
                <MainLayout>
                  <WorkProcessListing />
                </MainLayout>
              }
            />
            <Route
              path="/workitemdashboard"
              element={
                <MainLayout>
                  <WorkListDashboard />
                </MainLayout>
              }
            />
            <Route
              path="/user"
              element={
                <MainLayout>
                  <UserListing />
                </MainLayout>
              }
            />
            <Route
              path="/access"
              element={
                <MainLayout>
                  <AccessListing />
                </MainLayout>
              }
            />
            <Route
              path="/division"
              element={
                <MainLayout>
                  <DivisionListing />
                </MainLayout>
              }
            />
            <Route
              path="/role"
              element={
                <MainLayout>
                  <RoleListing />
                </MainLayout>
              }
            />
            <Route
              path="/organization"
              element={
                <MainLayout>
                  <OraganizationListing />
                </MainLayout>
              }
            />
            <Route
              path="/worklist"
              element={
                <MainLayout>
                  <Worklist />
                </MainLayout>
              }
            />
            <Route
              path="/simpleuserEmployee"
              element={
                <MainLayout>
                  <SampEmpListing />
                </MainLayout>
              }
            />
            <Route
              path="/annexture"
              element={
                <MainLayout>
                  <AnnextureListing />
                </MainLayout>
              }
            />
            <Route
              path="/chapter"
              element={
                <MainLayout>
                  <ChapterListing />
                </MainLayout>
              }
            />
            <Route
              path="/question"
              element={
                <MainLayout>
                  <QuestionListing />
                </MainLayout>
              }
            />
            <Route
              path="/suggandactref"
              element={
                <MainLayout>
                  <SuggandactrefListing />
                </MainLayout>
              }
            />
            <Route
              path="/schedule"
              element={
                <MainLayout>
                  <ScheduleListing />
                </MainLayout>
              }
            />
            <Route
              path="/observation"
              element={
                <MainLayout>
                  <ObservationSelect />
                </MainLayout>
              }
            />
            <Route
              path="/observationforUser"
              element={
                <MainLayout>
                  <ObservationSelectUser />
                </MainLayout>
              }
            />
            <Route
              path="/observationView"
              element={
                <MainLayout>
                  <ObservationSelectView />
                </MainLayout>
              }
            />
            <Route
              path="/observationViewforUser"
              element={
                <MainLayout>
                  <ObservationSelectViewUser />
                </MainLayout>
              }
            />
            <Route
              path="/auditObservation"
              element={
                <MainLayout>
                  <AuditObservation />
                </MainLayout>
              }
            />
            <Route
              path="/auditObsHistory"
              element={
                <MainLayout>
                  <AuditObsHistory />
                </MainLayout>
              }
            />
            <Route
              path="/auditObsUser"
              element={
                <MainLayout>
                  <AuditObsUser />
                </MainLayout>
              }
            />
            <Route
              path="/auditObsUserHistory"
              element={
                <MainLayout>
                  <AuditObsUserHistory />
                </MainLayout>
              }
            />
            <Route
              path="/auditee"
              element={
                <MainLayout>
                  <AuditeeListing />
                </MainLayout>
              }
            />
            <Route
              path="/nearMissAccident"
              element={
                <MainLayout>
                  <NearMissAccidentListing />
                </MainLayout>
              }
            />
            <Route
              path="/dropdowns"
              element={
                <MainLayout>
                  <DropdownListing />
                </MainLayout>
              }
            />
            <Route
              path="/userProfile"
              element={
                <MainLayout>
                  <SampEmpProfile />
                </MainLayout>
              }
            />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
          </Routes>
        </main>
      </div>
    </>
  );
};

export default App;
